"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(price) {
    const parsedPrice = parseInt(String(price));
    const isNegative = parsedPrice < 0;
    const stringPrice = String(Math.abs(parsedPrice)); // ? 소수점, 부호(-) 버리기
    return stringPrice || stringPrice === '0'
        ? `${isNegative ? '-' : ''}${stringPrice.split(/(?=(?:...)*$)/).join(',')}`
        : '';
}
exports.default = default_1;
